
export const ALERT_ACTIONS = {
  CLOSE: 'close',
  CANCEL: 'cancel',
  CONFIRM: 'confirm',
};

